import * as React from 'react';

import PortfolioBenefitsModule from 'bundles/unified-description-page-common/components/modules/project-instructions/PortfolioBenefitsModule';

import _t from 'i18n!nls/xdp';

const PortfolioProjectBenefitsModuleRenderer = () => {
  return (
    <PortfolioBenefitsModule
      description={_t(
        'Projects give you real-world challenges to solve with industry tools, and produce work samples that you can add to your Coursera Skills Profile to help you stand out to employers.'
      )}
      title={_t('Demonstrate your skills with Projects')}
    />
  );
};

export default PortfolioProjectBenefitsModuleRenderer;
